import { CoachSettlingRaw } from './coachSettling';
import { UnlockContext } from './briefingPhase';

/**
 * 강사 정착 목 데이터.
 *
 * 🔴 **핸드오프 문서(B8)의 JSON 예시와 형태가 같아야 합니다.**
 * 목이 서버보다 후하면 화면은 멀쩡해 보이고 실제 센터에서 빈칸이 뜹니다.
 * QA 가 통과합니다 — 기존 기획서 §5-④ 가 「실제로 그랬습니다」라고 적어 둔 함정입니다.
 *
 * 값은 기획서 `DAILY_OPS_BRIEFING_COACH_ONBOARDING.md` §4 의 예시 그대로입니다:
 *
 *   ✅ 김한솔  회원 12명 · 수강권 12 · 일지 8/9   잘 하고 있어요
 *   ✅ 조은오  회원  9명 · 수강권  9 · 일지 5/6   잘 하고 있어요
 *   ⚠️ 성  현  회원  8명 · 수강권  2 · 일지 0     수강권 6건 미등록
 *   🔴 한은지  아직 앱 로그인 전                   담당 7명이 라포에 없음
 *
 * 커버리지는 **회원 42명 중 27명(64%)** 이 나옵니다.
 * D3 확정(「등록된 회원만 커버로 센다」) 기준이라 성현의 8명 중 2명만 세어집니다 —
 * 강사 단위로 통째 제외/포함하던 때보다 낮게 나오는 것이 맞습니다.
 */
export const mockCoachSettling = (): CoachSettlingRaw[] => [
    {
        coachId: 'coach-1',
        name: '김한솔',
        appLoggedIn: true,
        centerAccepted: true,
        memberCount: 12,
        inviteSent: 12,
        inviteAccepted: 11,
        membershipRegistered: 12,
        scheduleRegistered: 12,
        lessonsDone: 9,
        journalWritten: 8,
        joinedOn: null,
    },
    {
        coachId: 'coach-2',
        name: '조은오',
        appLoggedIn: true,
        centerAccepted: true,
        memberCount: 9,
        inviteSent: 9,
        inviteAccepted: 8,
        membershipRegistered: 9,
        scheduleRegistered: 9,
        lessonsDone: 6,
        journalWritten: 5,
        joinedOn: null,
    },
    {
        // ⚠️ 회원은 연결했는데 수강권이 6건 남았다 — 처방이 교육이 아니라 면담이다
        coachId: 'coach-3',
        name: '성현',
        appLoggedIn: true,
        centerAccepted: true,
        memberCount: 8,
        inviteSent: 8,
        inviteAccepted: 6,
        membershipRegistered: 2,
        scheduleRegistered: 2,
        lessonsDone: 0,
        journalWritten: 0,
        joinedOn: null,
    },
    {
        // 🔴 아직 시작도 안 했다. 담당 7명의 기록이 전혀 안 쌓인다
        coachId: 'coach-4',
        name: '한은지',
        appLoggedIn: false,
        centerAccepted: false,
        memberCount: 7,
        inviteSent: 0,
        inviteAccepted: 0,
        membershipRegistered: 0,
        scheduleRegistered: 0,
        lessonsDone: 0,
        journalWritten: 0,
        joinedOn: null,
    },
    {
        // 🆕 신규 강사 — 기존 강사와 같은 잣대로 평가하지 않는다 (기획서 §7)
        coachId: 'coach-5',
        name: '박지훈',
        appLoggedIn: true,
        centerAccepted: true,
        memberCount: 5,
        inviteSent: 4,
        inviteAccepted: 3,
        membershipRegistered: 3,
        scheduleRegistered: 2,
        lessonsDone: 2,
        journalWritten: 1,
        joinedOn: '2026-08-19', // 8일차
    },
    {
        // 🔴 일지 집계 경로가 아직 없는 강사 — null 을 0 으로 바꾸지 않는다
        coachId: 'coach-6',
        name: '장재혁',
        appLoggedIn: true,
        centerAccepted: true,
        memberCount: 1,
        inviteSent: 1,
        inviteAccepted: 1,
        membershipRegistered: 1,
        scheduleRegistered: 1,
        lessonsDone: null,
        journalWritten: null,
        joinedOn: null,
    },
];

/**
 * 신호 해금 상황.
 *
 * 기본은 **도입 12일차** 로 뒀습니다 — 기획서 §6-2 의 「라포 정착 12일차」와 같은 시점이라
 * 강사 정착과 벤치마크는 열렸고 소진 페이스는 아직 닫힌 상태를 볼 수 있습니다.
 */
export const mockUnlockContext = (): UnlockContext => ({
    centerDayCount: 12,
    coachCount: 6,
    membersWithMembership: 27,
    measuredWeeks: 1,
    lessonCount: 17,
});

/** 오래 쓴 센터 — 신호가 전부 열린 상태를 확인할 때 씁니다 */
export const mockUnlockContextMature = (): UnlockContext => ({
    centerDayCount: 240,
    coachCount: 18,
    membersWithMembership: 200,
    measuredWeeks: 30,
    lessonCount: 1200,
});
